import { Suspense, lazy } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom/dist';
import TransitionComponent from '../utils/Transition';

const HomePage = lazy(() => import('../components/Home'));
const AboutPage = lazy(() => import('../components/About'));
const ContactPage = lazy(() => import('../components/Contact'));
const WorkPage = lazy(() => import('../components/Work'));
const SkillsPage = lazy(() => import('../components/Skills'));
const ResumePage = lazy(() => import('../components/Resume'));
const ErrorPage = lazy(() => import('../components/Error'));

const RoutesComponent = () => (
  <Routes>
    <Route path="" element={<Outlet />}>
      <Route
        index
        element={
          <TransitionComponent>
            <HomePage />
          </TransitionComponent>
        }
      />
      <Route
        path="/about"
        element={
          <TransitionComponent>
            <AboutPage />
          </TransitionComponent>
        }
      />
      <Route
        path="/skills"
        element={
          <TransitionComponent>
            <SkillsPage />
          </TransitionComponent>
        }
      />
      <Route
        path="/work"
        element={
          <TransitionComponent>
            <WorkPage />
          </TransitionComponent>
        }
      />
      <Route
        path="/work/:id"
        element={
          <TransitionComponent>
            <WorkPage />
          </TransitionComponent>
        }
      />
      <Route
        path="/contact"
        element={
          <TransitionComponent>
            <ContactPage />
          </TransitionComponent>
        }
      />
    </Route>
    <Route path="/my-resume" element={<ResumePage />} />
    <Route path="/*" element={<ErrorPage />} />
  </Routes>
);

const RoutesContainer = () => {
  return (
    <Suspense>
      <RoutesComponent />
    </Suspense>
  );
};

export default RoutesContainer;
